// extracted by mini-css-extract-plugin
export default {"container":"TextWithTooltip_container__Z0nrf","label":"TextWithTooltip_label__6oxwB","tooltip":"TextWithTooltip_tooltip__4tNWi"};